module.exports = __webpack_public_path__ + "img/Platform-section-01-min.b74fb6d5.jpeg";